import React from 'react';
import styled from 'styled-components';
import useLang from '../../utils/useLang';
import { Navbar } from '../molecules';
import NewsDetail from '../organisms/newsDetail';

function Noticia() {

  return (
    <DivColumn>
      <Navbar />
      <NewsDetail/>
    </DivColumn>
  )
}
export default useLang(Noticia);

const DivColumn = styled.div`
  display: flex;
  flex-flow: column;
`;